module.exports = __webpack_public_path__ + "static/Hadozee_ranger_DND3_5_SW-7019424e8f1a25dbe79ce59817a12054.webp";